module.exports = __webpack_public_path__ + "static/media/full_width_version_tablet.d32998a2.jpg";